import ItemEmbed from 'components/Item/Embed.js'
import { ItemImage } from 'components/Item/Image.js'
import ItemYoutubeVideo from 'components/Item/YoutubeVideo.js'
import Video from 'components/Video'
import { View } from 'components/View'
import { MOTIVATION_MODEL_VIDEO_TYPE } from 'models/daos/motivation/constants'
import React from 'react'

const TYPE = {
  ...MOTIVATION_MODEL_VIDEO_TYPE,
  HTML5: 'html5'
}

export default function ItemMedia ({
  video,
  videoType,
  isBig,
  onClickVideo,
  isCompact,
  image,
  photos,
  aspectRatio,
  isVeryTall,
  title
}) {
  const images = []
  if (photos?.length) {
    images.push(...photos.map(photo => photo?.original_size?.url))
  } else {
    images.push(image)
  }

  const isYoutubeVideo = videoType === MOTIVATION_MODEL_VIDEO_TYPE.YOUTUBE
  const isHtml5Video = [
    MOTIVATION_MODEL_VIDEO_TYPE.TUMBLR,
    TYPE.HTML5
  ].includes(videoType)
  const isEmbedVideo = !isYoutubeVideo && !isHtml5Video
  let VideoComponent
  const shouldRenderVideo = video && !isCompact
  if (shouldRenderVideo && isEmbedVideo) {
    VideoComponent = ItemEmbed
  } else if (shouldRenderVideo && isYoutubeVideo) {
    VideoComponent = ItemYoutubeVideo
  } else if (shouldRenderVideo) {
    VideoComponent = Video
  }

  return (
    <div
      style={{
        maxWidth: '40em'
      }}
    >
      {VideoComponent
        ? (
          <VideoComponent
            shouldAutoPlay
            source={video}
            type={videoType}
            isBig={isBig}
            onClick={onClickVideo}
            isMuted={false}
            // To force video.js to re-render
            key={video}
          />
          )
        : (
            images.map((image, index) => {
              return (
                <View
                  mt={!!index}
                  key={image}
                >
                  <ItemImage
                    source={image}
                    title={title}
                    isBig={isBig}
                    aspectRatio={aspectRatio}
                    isVeryTall={isVeryTall}
                  />
                </View>
              )
            })
          )}
    </div>
  )
}

ItemMedia.ASPECT_RATIO = ItemImage.ASPECT_RATIO
